import MapView = require("./MapView");
import template = require("../templates/rhythm-gis-template");
import Base = require("./base-view");

class AppLayoutView extends Base<any> {

    static about = `
The app/application/rhythm-gis-app uses this view to render the maplet.
    `;

    execute(options) {

        this.className = "app";
        options.template = options.template || template;

        this.regions = {
            "maplet-region": ".map-region",
            toolbar: ".toolbar-region"
        };

        return super.execute(options);
    }

}

export = AppLayoutView;